import moment from 'moment';
import { DirectionTypeMap, ReviewStatusMap } from '@/types/exception-management/dictionaries';

export default function() {
  return {
    adapterDataForViewModel: {
      reviewStatushandler: {
        dataMap: ReviewStatusMap,
        model: [],
        onChange: (str: String) => {
          this.filterParam.reviewStatus = str;
        }
      },
      //抬杆原因
      liftCausesTypesHandler: {
        dataMap: this.$store.state.dictionaries.allDictionaries.cp_order_hand_lift_record_lift_cause,
        model: [],
        onChange: (str: String) => {
          this.filterParam.liftCauses = str;
        }
      },
      //进出场方向
      directionTypeHandler: {
        dataMap: DirectionTypeMap,
        model: [],
        onChange: (str: String) => {
          this.filterParam.directions = str;
        }
      },
      //抬杆方式 操作记录
      LiftTypesHandler: {
        dataMap: this.$store.state.dictionaries.allDictionaries.cp_order_hand_lift_record_lift_type,
        // Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_order_hand_lift_record_lift_type)
        // list: Utils.toLabelVal(LiftTypesMap),
        // model: [],
        onChange: (str: String) => {
          this.filterParam.liftTypes = str;
        }
      },

      plateModel: false
    },
    // stopDay: '', //停车：几天以上
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',
    liftStartTime: moment(new Date()).format('YYYY-MM-DD 00:00:00'), // 开始时间
    liftEndTime: moment(new Date()).format('YYYY-MM-DD 23:59:59'), // 结束时间
    directions: '', //进出场类型
    reviewStatus: '', //审核状态
    liftTypes: [], //抬杆方式
    liftCauses: '', //抬杆原因
    operater: '', //操作人姓名
    // cleanStartTime: '',
    // cleanEndTime: '',
    // authTypes: [], // 车辆类型,多个类型逗号分隔（00：临停小车 01：临停大车 02：产权车 03：月卡车）
    // carTypes: [], // 车型,多个类型逗号分隔,00：小车，01：大车
    liftTimeOrderBy: '',
    channelIds: []
  };
}
